import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SwitchOrganisationModalComponent} from "./switch-organisation-modal.component";
import {ButtonModule} from "@xref/xref-lib";

@NgModule({
  declarations: [SwitchOrganisationModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [SwitchOrganisationModalComponent]
})
export class SwitchOrganisationModalModule {
}
